import { SxProps, Theme } from '@mui/material';

const title: SxProps<Theme> = {
  marginTop: 2,
  marginBottom: {
    xs: 2,
    md: 0,
  },
};

const header: SxProps<Theme> = {
  display: 'flex',
  flexDirection: {
    xs: 'column',
    md: 'row',
  },
  justifyContent: 'space-between',
  alignItems: {
    xs: 'flex-start',
    md: 'flex-end',
  },
};

const styles = {
  title,
  header,
};

export default styles;
